export default function FollowupFilters({

    value,

    counts={},

    onChange

}){

    const filters=[

        {

            key:"all",

            label:"All"

        },

        {

            key:"pending",

            label:"Pending"

        },

        {

            key:"completed",

            label:"Completed"

        },

        {

            key:"overdue",

            label:"Overdue"

        }

    ];

    return(

        <div className="crm-followup-filters">

            {

                filters.map(filter=>

                    <button

                        key={filter.key}

                        className={

                            value===filter.key

                            ?

                            "active"

                            :

                            ""

                        }

                        onClick={()=>

                            onChange(filter.key)

                        }

                    >

                        {filter.label}

                        <span>

                            {

                                counts[filter.key]

                                ??

                                0

                            }

                        </span>

                    </button>

                )

            }

        </div>

    );

}